import organizationConfig from '../config/organizationConfig';

function getOrganizationById({ orgId }) {
  const organizations = Object.values(organizationConfig);

  const matchedOrg = organizations.find((org) => org.orgId === orgId);

  return matchedOrg || organizationConfig.nextias;
}

// Both Made Easy brands (madeeasy and madeeasyprime) sit on the one org id, so the id
// is what to compare against — `organizationName` only ever resolves to whichever of
// the two `getOrganizationById` happens to match first.
function isMadeEasyOrg(orgId) {
  return orgId === organizationConfig.madeeasy.orgId;
}

export { isMadeEasyOrg };
export default getOrganizationById;
